import module from 'facturacion/facturas/module.js'
import template from './template.html'
import { cloneDeep } from 'lodash'

export class FacturacionFacturasIngresoMasivoListaItemComponent {
  data
  vinculandoNomina = false
  previsualizar = false

  vincularNomina (nomina) {
    console.log(nomina)

    if (nomina) {

      this.data.nominas.push(nomina)
    }
  }

  limpiarNominas () {
    this.data.nominas = []
  }

  visualizar () {
    this.dataTemporal = cloneDeep(this.data)
    this.previsualizar = true
  }
}

module.component('facturacionFacturasIngresoMasivoListaItem', {
  controller: FacturacionFacturasIngresoMasivoListaItemComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/facturacion/facturas/components/ingreso/masivo/lista/item/component.js